<template>
  <div>
    <AlignUser
      :user="user"
      class="clickable"
      @click="onClickUser"
    />
    <div
      v-if="isOkrVisible"
      :style="{ marginTop: '8px' }"
    >
      <div
        v-if="isLoading"
        :style="{ textAlign: 'center' }"
      >
        <a-spin size="small" />
      </div>
      <div
        v-else-if="okrItems.length === 0"
        :style="{ textAlign: 'center' }"
      >
        {{ $t('shared.noData') }}
      </div>
      <a-space
        v-else
        direction="vertical"
      >
        <a-checkbox
          v-for="okrItem in okrItems"
          :key="okrItem.id"
          :checked="entity.alignedStatementIds.includes(okrItem.id)"
          :disabled="user.uid === myUserId"
          @change="onCheckItem(okrItem.id, $event.target.checked)"
        >
          <a-space :style="{ alignItems: 'flex-start' }">
            <IconFont
              v-if="okrItem.type === 'objective'"
              type="iconmubiao"
              class="icon-block list-objective-icon"
            />
            <KeyResultIcon
              v-else
              class="list-kr-icon"
            />
            <div v-html="okrItem.content" />
          </a-space>
        </a-checkbox>
      </a-space>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import { align, unalign } from '@/api/okr'
import { getMyObjective } from '@/graphql/okr'
import useOkr from '@/composables/use-okr'
import AlignUser from './AlignUser'
import KeyResultIcon from '@/components/KeyResultIcon'

export default {
  name: 'UserOkr',
  components: {
    KeyResultIcon,
    AlignUser
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  emits: [
    'update:isAligning',
    'aligned'
  ],
  setup (props, { emit }) {
    const { state } = useStore()
    const myUserId = computed(() => state.user.uid)
    const okrItems = ref([])
    const isOkrVisible = ref(false)

    const { getPublishedOkrByCycle, isLoading } = useOkr()

    function onClickUser () {
      isOkrVisible.value = !isOkrVisible.value

      if (isOkrVisible.value) {
        getPublishedOkrByCycle(props.user.uid)
          .then(res => {
            okrItems.value = res.objectives.reduce((arr, objective) => {
              arr.push({
                id: objective.statementId.id,
                content: objective.content,
                type: 'objective',
                objectiveId: objective?.relatedObjectiveId?.id
              })
              arr.push(...objective.keyResults.map(keyResult => ({
                id: keyResult.statementId.id,
                content: keyResult.content,
                type: 'keyResult'
              })))
              return arr
            }, [])
          })
      }
    }

    function onCheckItem (aligningId, checked) {
      emit('update:isAligning', true)
      const fn = checked ? align : unalign
      fn(props.entity.statementId, aligningId)
        .then(() => getMyObjective(props.entity.id))
        .then(updatedEntity => emit('aligned', updatedEntity))
        .finally(() => emit('update:isAligning', false))
    }

    return {
      isLoading,
      isOkrVisible,
      onClickUser,
      okrItems,
      onCheckItem,
      myUserId
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-checkbox-wrapper) {
  display: flex;
  align-items: flex-start;
}

:deep(.ant-checkbox) {
  margin: 3px 0;
}
</style>
